import { gql } from '@apollo/client'

const UPDATE_SELECTION_ITEM_MUTATION = gql`
  mutation updateColumnSelection($id: ID!, $attributes: ColumnSelectionInput!) {
    updateColumnSelection(id: $id, attributes: $attributes) {
      id
    }
  }
`
export default UPDATE_SELECTION_ITEM_MUTATION
